import { type NounKeys } from '../../constants/nouns';
import { ProductKeys } from '../../constants/product-keys';

const ATLASSIAN_OWNED_3P_PRODUCTS: ReadonlySet<string> = new Set([
	ProductKeys.Loom,
	ProductKeys.ConfluenceDC,
	ProductKeys.JiraDC,
	ProductKeys.JsmDC,
	ProductKeys.AtlassianWebCrawler,
]);

const ARTIFACTS_CONNECTOR_SUFFIX = '-artifacts-connector';

export const isAtlassianOwned3pProduct = (key: ProductKeys | NounKeys | undefined): boolean =>
	key !== undefined &&
	(ATLASSIAN_OWNED_3P_PRODUCTS.has(key) || key.endsWith(ARTIFACTS_CONNECTOR_SUFFIX));
